import { Box, Container, Typography, Divider, Stack } from "@mui/material";
import { Loading } from "src/components/utils/Loading";
import { useApplicationParameters } from "src/api/client-api/appParams";
import { BaseStringUpload } from "../AppParams/BaseStringUpload";
import { useTranslation } from "react-i18next";

export const EveaAskorSettings = () => {
    const { applicationParameters } = useApplicationParameters();
    const { t } = useTranslation();

    if (applicationParameters === undefined) return <Loading />;

    return (
        <Container
            component="main"
            maxWidth={false}
            sx={{
                m: "0",
                p: "5rem !important",
            }}
        >
            <Typography variant="h1">{t("evea.askor.settings.title")}</Typography>
            <Box sx={{ py: 2 }} />
            <Divider />
            <Box sx={{ py: 2 }} />

            <Stack gap={"30px"}>
                <BaseStringUpload
                    label={t("evea.askor.settings.client.url.title")}
                    description={t("evea.askor.settings.client.url.message")}
                    appParamKey={"eveaAskorUrl"}
                />
            </Stack>
            <Box sx={{ py: 2 }} />
        </Container>
    );
};
